const TIME_DROPDOWN_OPTIONS_INTERVAL = 15

export { TIME_DROPDOWN_OPTIONS_INTERVAL }
